<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="BdrFws_1d01_P20"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import BdrFws_1d01_P20 from '@/device-products/BdrFws_1d01_P20.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
    ],
    simulationDevices: [
      { id: 0, component: BdrFws_1d01_P20, deviceLabel: 'Codierung 1: FREQUENCY', props: { leiterplattenCodierung: 1 } }, // swapped after FWR2018
    ],
  }),
};
</script>

<style>

</style>
